import React, { useState, useEffect } from "react";
import Spinner from "../../../components/ui/BackDrop";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogTitle, FormControlLabel, FormControl, Grid, Radio, RadioGroup, TextField, Toolbar, Typography } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from '@material-ui/icons/Cancel';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import { CalendarioSobreturno } from "./CalendarioSobreturno";
import { useForm } from "../../../hooks/useForm";
import { nuevoSobreturno } from "../../../actions/turnos/agenda";
import { Redirect } from "react-router-dom";
import moment from "moment";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";
import { ModalTurnosDelDia } from "./ModalTurnosDelDia";
import { efectorHorariosLimpiar, fetchEfectorHorarios } from "../../../actions/turnos/efectorHorarios";
import { OBRAS_SOCIALES, TIPO_TURNO } from "../../../utils/constants";
import { getTurnosCtaCtePorGrupo } from "../../../actions/turnos/ctaCte";
import { FormularioCoseguro } from '../coseguros/FormularioCoseguro';

const useStyles = makeStyles((theme) => ({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        width: "74%",
    },
    header: {
        background: '#68389F',
        color: 'white'
    },
    botonera: {
        marginTop: 25,
        marginLeft: 55,
        marginBottom: 10,
        paddingBottom: 13
    },
    botonOtroTurno: {
        marginLeft: 100,
        marginBottom: 20,
        paddingBottom: 13,
    },
    formControl: {
        marginTop: 5,
        minWidth: 200,
        marginLeft: 20,
        margin: theme.spacing(1),
    },
}));

const transformDay = (day) => {
    switch (day) {
        case 0:
            return "DO"
        case 1:
            return "LU"
        case 2:
            return "MA"
        case 3:
            return "MI"
        case 4:
            return "JU"
        case 5:
            return "VI"
        case 6:
            return "SA"
        default:
            return null
    }
}

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
}

const formatHorario = (hora, minutos) => {
    return `${("0" + hora).slice(-2)}:${("0" + minutos).slice(-2)}`;
}

const stateInitial = {
    hora: '',
    minutos: '',
    idTipoTurno: 1,
    selectedDay: null,
}

export const ModalAltaSobreturno = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { open, setOpen, title, idEspecialidad, idCentroMedico, idProfesional, presencial, virtual, listaHorarios, setListaHorarios, setOtroSobreTurno,
        idObraSocial } = props;
    const { items: itemsHorariosProfesional } = useSelector((state) => state.efectorHorarios);
    const { afiliado } = useSelector((state) => state.afiliacion);
    const { saldo = 0 } = useSelector((state) => state.ctaCte);

    const [formValues, handleInputChange, , setearValor, , , , , setearVariosValores] = useForm(stateInitial);
    const { hora, minutos, idTipoTurno, selectedDay } = (formValues);
    //const [idTipoTurnoParam, setIdTipoTurnoParam] = useState(3);
    const [openPracticas, setOpenPracticas] = useState(false);
    const [openQuestion, setOpenQuestion] = useState(false);
    const [openDetalle, setOpenDetalle] = useState(false);
    const [otroTurno, setOtroTurno] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [turno, setTurno] = useState(false);

    const [error, setError] = useState(null);

    const handleSaveSobreturno = (continuarOtroTurno = false) => {
        setError(null)
        if (!hora || !minutos) {
            setError('Los campos horas y minutos deben estar completos');
        } else {
            const before = moment({ hour: listaHorarios[0].hora.substring(0, 2), minute: listaHorarios[0].hora.substring(3, 5) });
            const after = moment({ hour: listaHorarios[listaHorarios.length - 1].hora.substring(0, 2), minute: listaHorarios[listaHorarios.length - 1].hora.substring(3, 5) });
            if (moment({ hour: hora, minute: minutos }).isBetween(before.subtract(1, 'minutes'), after.add(1, 'minutes'))) {
                const horario = formatHorario(hora, minutos);
                if (listaHorarios.some(s => horario.includes(s.hora))) {
                    setError('Ya existe un turno en ese horario');
                }
                else {
                    setOpenQuestion(true);
                    setOtroTurno(continuarOtroTurno);
                }
            } else {
                setError('Debe ingresar un horario valido para el sobreturno dentro del rango del día')
            }
        }
    }

    const handleSendSaveSobreturno = () => {
        const cargaPracticas = listaHorarios[0]?.especialidad?.exentoCoSeguro ? false : true;

        dispatch(nuevoSobreturno(idEspecialidad, idCentroMedico, idProfesional, afiliado.id_afiliado, afiliado.carnet,
            transformDay(moment(selectedDay).day()), selectedDay, formatHorario(hora, minutos), idTipoTurno,
            !otroTurno && setRedirect, otroTurno && closeAll, afiliado.idAfiliadoExterno,
            cargaPracticas ? () => setOpenPracticas(true) : null, 
            () => setOpenQuestion(false), setTurno)
        );
        // otroTurno && closeModal();
        otroTurno && setOtroSobreTurno(true);
    }

    useEffect(() => {
        if (afiliado.idGrupoFamiliar > 1)
            dispatch(getTurnosCtaCtePorGrupo(afiliado.idGrupoFamiliar));
    }, [dispatch]);

    useEffect(() => {
        setError(null);
        setearVariosValores({ hora: '', minutos: '', idTipoTurno: 1 });
        // eslint-disable-next-line
    }, [selectedDay])

    useEffect(() => {
        setError(null);
        if (hora && minutos) {
            const horaSobreTurno = moment({ hour: hora, minute: minutos });

            if (horaSobreTurno.isValid()) {
                const parametrizacionVigente = itemsHorariosProfesional.filter(s => !s.inHabilitado)
                    .filter(s => s.dia === transformDay(moment(selectedDay).day()))
                    .filter(s => moment(moment(selectedDay).format('YYYY-MM-DD')).isBetween(moment(s.fechaInicio).format('YYYY-MM-DD'), moment(s.fechaFin).format('YYYY-MM-DD'), undefined, '[]'))
                    .filter(s => horaSobreTurno.isBetween(moment({ hour: s.horaDesde, minute: s.minDesde }), moment({ hour: s.horaHasta, minute: s.minHasta })));

                if (parametrizacionVigente.length) {
                    //setIdTipoTurnoParam(parametrizacionVigente[0].idTipoTurno);
                    parametrizacionVigente[0].idTipoTurno !== TIPO_TURNO.AMBOS && setearValor("idTipoTurno", parametrizacionVigente[0].idTipoTurno);
                } else {
                    //setIdTipoTurnoParam(TIPO_TURNO.AMBOS);
                }
            } else {
                setError('Debe ingresar un horario valido')
            }
        }
        // eslint-disable-next-line
    }, [hora, minutos, itemsHorariosProfesional, selectedDay])

    useEffect(() => {
        dispatch(efectorHorariosLimpiar());
    }, [dispatch])

    useEffect(() => {
        selectedDay && idProfesional && idCentroMedico && idEspecialidad && dispatch(fetchEfectorHorarios(idCentroMedico, idProfesional, idEspecialidad));
    }, [dispatch, selectedDay, idCentroMedico, idProfesional, idEspecialidad]);

    const closeAlertModal = () => {
        setOtroTurno(false);
        setOpenQuestion(false);
    }

    const closeModal = () => {
        setOpen(false);
        setOtroTurno(false);
    }

    const closeAll = () => {
        setOpen(false);
        setOtroTurno(false);
        setOpenQuestion(false);
    }

    const closeModalPracticas = () => {
        !otroTurno && setRedirect(true);
        setOpenPracticas(false);
        closeModal();
    }



    const habilitarVirtual = listaHorarios.some(x => x.idTipoTurno === TIPO_TURNO.VIRTUAL);
    
    const habilitarPresencial = listaHorarios.some(x => x.idTipoTurno === TIPO_TURNO.PRESENCIAL);

   
    return (
        <Dialog
            maxWidth="lg"
            fullWidth={true}
            open={open}
            // onClose={closeModal}
        >
            <DialogTitle className={classes.header}>
                <Toolbar >
                    <Typography variant="h6" >
                        {title}
                    </Typography>
                </Toolbar>
            </DialogTitle>
            <Spinner />

            {openPracticas &&
                <Dialog
                    maxWidth="md"
                    fullWidth={true}
                    open={openPracticas}
                    // onClose={closeModal}
                >
                    <DialogTitle >
                        {'Practicas Turno'}                        
                    </DialogTitle>
                    <FormularioCoseguro
                        closeModalPracticas={closeModalPracticas}
                        usuarioTurnoSeleccionado={turno}
                        pantallaAltaSobretTurnos={true}
                        idObraSocial={idObraSocial}
                        idAgenda={turno?.idAgenda}
                    />
                </Dialog>
            }

            <div className={classes.root}>
                <Grid container justify="center">
                    <Grid item xs={12} md={5} style={{ marginRight: 70 }} >
                        <CalendarioSobreturno
                            setListaHorarios={setListaHorarios}
                            idAfiliado={afiliado.id_afiliado}
                            idEspecialidad={idEspecialidad}
                            idCentroMedico={idCentroMedico}
                            idProfesional={idProfesional}
                            setearValor={setearValor}
                            selectedDay={selectedDay}
                            presencial={presencial}
                            virtual={virtual}
                            idAfiliadoExterno={afiliado.idAfiliadoExterno}
                        />
                    </Grid>
                    <Grid item xs={12} md={5} style={{ marginTop: 50, marginLeft: 30 }}>
                        {
                            (selectedDay === null || afiliado.fecha_fin_cobertura === null
                                || moment(selectedDay.toISOString()).isSameOrBefore(moment(afiliado.fecha_fin_cobertura).add(1, 'days')))
                                ?
                                <Grid container justify="center">
                                    {listaHorarios.length > 0 &&
                                        <>
                                            {idObraSocial === OBRAS_SOCIALES.OSPEDYC && <Grid item xs={12}>
                                                {saldo === 0 &&
                                                    <Typography variant="h6" component="h3">
                                                        <strong>Saldo en CtaCte: ${saldo.toFixed(2)}</strong>
                                                    </Typography>}
                                                {saldo < 0 &&
                                                    <Typography variant="h6" component="h2" style={{ color: 'green' }}>
                                                        <strong>Saldo en CtaCte: ${(saldo * -1).toFixed(2)}</strong>
                                                    </Typography>}
                                                {saldo > 0 &&
                                                    <Typography variant="h6" component="h2" style={{ color: 'red' }}>
                                                        <strong>Saldo en CtaCte Deuda: ${saldo.toFixed(2)}</strong>
                                                    </Typography>}
                                            </Grid>}
                                            <Grid item xs={12}>
                                                <h3>Puede generar sobreturnos en el rango desde {listaHorarios[0].hora.substring(0, 2)}:{listaHorarios[0].hora.substring(3, 5)} a {listaHorarios[listaHorarios.length - 1].hora.substring(0, 2)}:{listaHorarios[listaHorarios.length - 1].hora.substring(3, 5)}hs</h3>
                                            </Grid>
                                            <Grid item xs={4} style={{ marginRight: 50 }}>
                                                <TextField
                                                    type='number'
                                                    margin="normal"
                                                    fullWidth={true}
                                                    disabled={!selectedDay}
                                                    label="Hora"
                                                    name="hora"
                                                    value={hora}
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        handleInputChange({ target: { name: 'hora', value: e.target.value.trim() } });
                                                    }}
                                                />

                                            </Grid>
                                            <Grid item xs={4}>
                                                <TextField
                                                    type='number'
                                                    margin="normal"
                                                    fullWidth={true}
                                                    disabled={!selectedDay}
                                                    label="Minutos"
                                                    name="minutos"
                                                    value={minutos}
                                                    autoComplete="off"
                                                    onChange={(e) => {
                                                        handleInputChange({ target: { name: 'minutos', value: e.target.value.trim() } });
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} style={{ marginTop: 25, textAlign: 'center' }}>
                                                <FormControl component="div">
                                                    <RadioGroup row aria-label="gender" name="idTipoTurno1" value={idTipoTurno} onChange={(e) => { setearValor('idTipoTurno', parseInt(e.target.value)) }}>
                                                        <FormControlLabel disabled={!habilitarPresencial} value={1} control={<Radio />} label="Presencial" style={{ marginRight: 45 }} />
                                                        <FormControlLabel disabled={!habilitarVirtual} value={2} control={<Radio />} label="Virtual" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                            <Grid style={{ marginTop: 15 }}>
                                                <h4>
                                                    SobreTurnos tomados del día: {listaHorarios.filter(s => s.sobreTurno).filter(s => s.idAfiliado || s.idAfiliadoExterno).length}
                                                    <Button
                                                        style={{ marginTop: -5 }}
                                                        size="large"
                                                        startIcon={<InsertInvitationIcon />}
                                                        onClick={() => { setOpenDetalle(true) }}
                                                    >
                                                    </Button>
                                                    <ModalTurnosDelDia
                                                        open={openDetalle}
                                                        items={listaHorarios}
                                                        setOpen={setOpenDetalle}
                                                        title={'Detalle de turnos'}
                                                    />
                                                </h4>
                                            </Grid>
                                        </>
                                    }
                                    {error &&
                                        <Grid item xs={12}>
                                            <h3 style={{ color: 'red' }}>{error}</h3>
                                        </Grid>
                                    }
                                </Grid>
                                :
                                <Typography color="error" align="center">Beneficiario/a con cobertura inactiva  para la fecha seleccionada</Typography>
                        }
                    </Grid>
                </Grid>

                <Grid className={classes.botonera} container >
                    <Grid item xs={10}>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={closeModal}
                            >
                                CANCELAR
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                disabled={error || !hora || !minutos}
                                onClick={() => handleSaveSobreturno(false)}
                            >
                                CONFIRMAR
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid className={classes.botonOtroTurno} container >
                    <Grid item xs={10}>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                disabled={error || !hora || !minutos}
                                onClick={() => handleSaveSobreturno(true)}
                            >
                                CONFIRMAR Y SACAR OTRO
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                {openQuestion &&
                    <AlertFinalizadoStepper
                        open={openQuestion}
                        pregunta={"Nuevo Sobreturno"}
                        dialogText={`Se va a generar un nuevo sobreturno para el afiliado ${afiliado.apellido_y_nombre} para el ${new Date(selectedDay).toLocaleString("es", optionsfecha)} a las ${formatHorario(hora, minutos)}hs esta seguro?`}
                        buttonCancel={"Cancelar"}
                        buttonSubmit={"Continuar"}
                        handleClose={closeAlertModal}
                        handleSend={handleSendSaveSobreturno}
                    />
                }
                {redirect && (
                    <Redirect
                        to={{
                            pathname: "/turnos",
                        }}
                    />
                )}
            </div>
        </Dialog>
    );

};
